import { Component } from '@angular/core';
import { IQuote } from './components/quote/quote.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'ecclesia-web';
  quote1: IQuote = {
    quote:
      '"Cada uno ponga al servicio de los demás el don que haya recibido, administrando fielmente la gracia de Dios en sus diversas formas." - Pedro 4:10',
    background: 'color1',
  };

  quote2: IQuote = {
    quote:
      '"Los pensamientos del solícito ciertamente van a abundancia; mas los de todo presuroso, indefectiblemente a pobreza." - Proverbios 21:5',
    background: 'color2',
  };
}
